<mat-form-field appearance="outline" class="full-width">
  <mat-label>{{label}}</mat-label>
  <mat-select [(value)]="_selected" [disabled]="disabled">
    <mat-option [value]="null" *ngIf="!noEmptyValue"></mat-option>
    <mat-option *ngFor="let currentType of types" [value]="currentType">
      {{currentType.description || currentType}} 
    </mat-option>
  </mat-select>
</mat-form-field>
